import { createGenericStore } from '@/stores/utils/genericStore.js' // Assumes genericStore.js is in your main app's 'resources/js/utils/'

// 1. Define your custom options
const userPermissionStoreOptions = {
  state: () => ({
    // Add custom state properties here
    // e.g., customPropertyExample: null
  }),

  // Custom getters
  getters: {
    // e.g., myCustomGetter(state) { return ... }
  },

  // Custom actions
  actions: {
    // e.g., async myCustomAction() { ... }
  }
}

// 2. Create the store hook using your generic factory
export const useUserPermissionStore = createGenericStore(
  'permissions', // Base Store ID
  '/api/v1/user-permissions', // API Endpoint
  userPermissionStoreOptions // Pass in your custom logic
)
